"use client";

import { getMargins, getPaddings } from "@/utils/theme-helper";

export interface TypographyComponentProps {
  text: string;
  size: "xs" | "sm" | "md" | "lg" | "xl" | "2xl" | "4xl";
  textColor: string;
  padding: string;
  margin: string;
  align: "center";
}

const TypographyComponent: React.FC<{
  config: TypographyComponentProps;
}> = ({ config: typography }) => (
  <div
    style={{ color: typography.textColor, textAlign: typography.align }}
    dangerouslySetInnerHTML={{ __html: typography.text }}
    className={`styled-description homepage-text-${typography?.size ?? "sm"} ${getMargins(typography.margin)} ${getPaddings(typography.padding)}`}
  ></div>
);

export default TypographyComponent;
